import {tokens} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import type {Props as CardProps} from '@/components/card'
import Card from '@/components/card'
import {Section, Layout, BackgroundWrapper} from '@helios/shared/styles/grid'
import {Text} from '@helios/shared/styles/typography'
import mq from '@helios/shared/utils/media-query'

type SimpleCardGridCard = CardProps & {
    description?: string
}

export interface Props {
    title?: string
    cards: SimpleCardGridCard[]
}

const SimpleCardGrid = ({title, cards}: Props) => (
    <BackgroundWrapper color="muted">
        <Section>
            {title && <StyledText variant="heading-base">{title}</StyledText>}

            <StyledLayout variant="three-equal" alignItems="stretch">
                {cards.map((card, i) => (
                    <Card key={`${card.title}-${i}`} {...card} ctaAsButton justifyImage="start" />
                ))}
            </StyledLayout>
        </Section>
    </BackgroundWrapper>
)

const StyledText = styled(Text)`
    margin-bottom: ${tokens.spacing40};
`

const StyledLayout = styled(Layout)`
    ${mq.min('lg')} {
        gap: ${tokens.spacing40};
    }
`

export default SimpleCardGrid
